import { DatePickerProps } from "./datepicker.props";
import ModernDatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import { useState } from "react";
import { DateService } from "src/services";

export const DatePicker: React.FC<DatePickerProps> = ({ className, value, placeholder, onChange }) => {

    const [now] = useState(DateService.getPersianDate(new Date()));
    const [maxDate] = useState({
        year: now.year(),
        month: now.month(),
        day: now.date(),
    });

    const [state, setState] = useState(() => {

        if (!value) return null;

        let date = new Date(value);
        if (!date.getFullYear) date = new Date();

        const newDate = DateService.getPersianDate(date);
        return ({
            year: newDate.year(),
            month: newDate.month(),
            day: newDate.date(),
        });
    });

    const onDateChange = (selectedDate: any) => {
        const fromDate = DateService.gregorianDate(selectedDate.year, selectedDate.month, selectedDate.day);
        setState((s) => ({ ...s, ...selectedDate }));
        onChange(fromDate);
    };

    return (
        <div>
            <ModernDatePicker
                calendarClassName="custom-calendar"
                calendarTodayClassName="custom-today-day"
                maximumDate={maxDate}
                inputClassName={className}
                value={state}
                onChange={onDateChange}
                inputPlaceholder={placeholder}
                shouldHighlightWeekends
                locale="fa"
            />
        </div>
    );

};